import { h, Component } from 'preact';
import util from 'preact-util';
import { observer } from 'mobx-preact';
import { Text, Localizer, withText } from 'preact-i18n';
import Markdown from 'preact-markdown';

import localUtil from '../../lib/util';
import fields from '../../lib/fields';

import FormFieldsCompact from '../../components/form/fieldsCompact';
import Input from '../../components/form/input';
import DyrejournalSaleSearch from '../dyrejournal/search';

@withText(props => ({
    orderNumber: <Text id='input.orderNumber-help'>orderNumber</Text>,
    name: <Text id='input.name-help'>name</Text>,
    description: <Text id='input.description-help'>description</Text>,
    installation: <Text id='input.installation-help'>installation</Text>,
    url: <Text id='input.url-help'>url</Text>,
}))
@observer
class NewTimeTracker extends Component {
  	constructor(props) {
        super(props);
        this.state = {
            sections: fields.get('timeTracker'),
        };
    }

    createTimeTracker = async () => {
        const { callback = () => {} } = this.props;
        const { timeTrackerStore } = this.props.stores;
        const { newTimeTracker } = timeTrackerStore;
        const response = await timeTrackerStore.adminCreate(newTimeTracker);
        if (response.status === 201) {
            callback();
        }
    }

    componentDidMount() {
        const { idx, id, isNew } = this.props;
        const { timeTrackerStore } = this.props.stores;
        if (!isNew) {
            // timeTrackerStore.adminSetFromIdx(idx);
            timeTrackerStore.adminSetFromId(id);
        }
    }

    render() {
        const { week, isNew, drawerLevel } = this.props;
        const { sections } = this.state;
        const { userStore, timeTrackerStore } = this.props.stores;
        const { user, isAdmin } = userStore;
        const { newTimeTracker, timeTracker } = timeTrackerStore;
        const darkmode= util.getNestedValue(user, 'settings.darkmode');
        const objectName = isNew ? 'newTimeTracker' : 'timeTracker';

        return (<>
            <div class='w-100 d-flex justify-content-center'>
                <div class='w-100' style='max-width: 960px; padding-top: 20px; padding-bottom: 100px;'>
                    {/* <div class='w-100 d-flex flex-column justify-content-start'>
                        <xmp>{JSON.stringify(user.settings, null, 2)}</xmp>
                    </div> */}
                    {/* <xmp>{JSON.stringify(newCustomer, null, 4)}</xmp> */}
                    <h5 class='ms-3 mb-3'>
                        {isNew ? <Text id='timetracker.new'>New timetracker</Text> : <Text id='timetracker.edit'>Edit timetracker</Text>}
                    </h5>
                    <div class='px-3 mb-3'>
                        <label class='form-label small text-body-secondary mb-0'>
                            <Text id='timetracker.visitor'>Client (visitor to invoice)</Text>
                        </label>
                        <DyrejournalSaleSearch
                            stores={this.props.stores}
                            key={'tt-visitor'}
                            holdingStore={this.props.stores.visitorStore}
                            searchResultList={'visitorResults'}
                            skipSaleUpdate={true}
                            searchResultsLine={(e, idx, selectedIndex) => (
                                <div class={`d-flex flex-column px-3 py-1 ${idx === selectedIndex ? 'selected' : ''}`}>
                                    <strong>{localUtil.showName(e)}</strong>
                                    <small class='text-body-secondary'>{e.cellphone}</small>
                                </div>
                            )}
                            callback={async (visitor) => {
                                const client = localUtil.showName(visitor);
                                timeTrackerStore.updateObjectKeyValue(objectName, 'visitor', visitor.id);
                                timeTrackerStore.updateObjectKeyValue(objectName, 'client', client);
                                if (!isNew && timeTracker?.id) {
                                    await timeTrackerStore.adminUpdate(timeTracker.id, { visitor: visitor.id, client }, objectName);
                                }
                            }}
                        />
                    </div>
                    <div class='bg-light d-flex flex-column justify-content-start h-100 pt-3'>
                        <FormFieldsCompact stores={this.props.stores} sections={sections} holdingStore={timeTrackerStore} objectName={objectName} isNew={isNew} drawerLevel={drawerLevel} isAdmin={true} />
                    </div>
                    {isNew && <div class='w-100 d-flex flex-column justify-content-start mt-3 px-4 py-3 bg-light fixed-bottom' style={`bottom: 0; left: 0;`}>
                        <button type='button' class='btn btn-primary rounded-pill' onClick={this.createTimeTracker}>
                            {isNew ? <Text id='timetracker.create'>Create timetracker</Text> : <Text id='timetracker.save'>Save timetracker</Text>}
                        </button>
                    </div>}
                </div>
            </div>
        </>);
    }
}

export default NewTimeTracker;
